import ProfileFormContainer from './ProfileFormContainer';

export default ProfileFormContainer;
